export const excludeYourBetItems = (items) => items.filter(item => item.type === "Regular"
    || item.type === "Forecast"
    || item.type === "Tricast");
//# sourceMappingURL=excludeYourBetItems.js.map